export enum ValidatorErrorMessages {
  WEAK_PASSWORD = `Password MUST contain:
  
    - At least 1 special character
    - At least 1 digit
    - At least 1 Uppercase
    - At least 1 Lowercase`,
}

export enum PhoneNumberValidation {
  SHORT = 'TOO_SHORT',
  LONG = 'TOO_LONG',
}

export enum PhoneNumberValidationErros {
  SHORT = 'Phone number is too short!',
  INVALID = 'Phone number is invalid!',
}
